import React from 'react';
import CustomSelect from '../../../components/ui/CustomSelect';
import { parseRupiah } from '../../hris/recruitment/utils/formatRupiah';

interface Step4Props {
  formData: any;
  handleChange: (field: string, value: any) => void;
  errors?: Record<string, string>;
}

export default function Step4BankHistory({ formData, handleChange, errors = {} }: Step4Props) {
  const formatCurrencyInput = (value: any): string => {
    if (!value && value !== 0) return '';
    const numValue = typeof value === 'string' ? parseFloat(value.replace(/[^\d]/g, '')) : value;
    if (isNaN(numValue)) return '';
    return new Intl.NumberFormat('id-ID').format(numValue);
  };

  const handleCurrencyChange = (field: string, value: string) => {
    const rawValue = parseRupiah(value);
    if (rawValue === '') {
      handleChange(field, '');
      return;
    }
    const numValue = parseFloat(rawValue);
    handleChange(field, isNaN(numValue) ? '' : rawValue);
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Hubungan dengan Bank <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          value={formData.bank_relationship}
          onChange={e => handleChange('bank_relationship', e.target.value)}
          placeholder="Contoh: Nasabah Lama / Baru"
          className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500 transition-colors duration-200 ${
            errors.bank_relationship ? 'border-red-500' : 'border-gray-300'
          }`}
        />
        {errors.bank_relationship && (
          <p className="text-sm text-red-600 mt-1">{errors.bank_relationship}</p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Fasilitas Pembiayaan Terakhir
        </label>
        <input
          type="text"
          value={formData.last_facility}
          onChange={e => handleChange('last_facility', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors duration-200"
        />
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Kualitas Kredit Terakhir <span className="text-red-500">*</span>
          </label>
          <CustomSelect
            value={formData.last_credit_quality}
            onChange={v => handleChange('last_credit_quality', v)}
            placeholder="Pilih"
            width="w-full"
            error={!!errors.last_credit_quality}
            color="blue"
            options={[
              { value: 'lancar', label: 'Lancar' },
              { value: 'dpl', label: 'Dalam Perhatian Khusus' },
              { value: 'kurang_lancar', label: 'Kurang Lancar' },
              { value: 'diragukan', label: 'Diragukan' },
              { value: 'macet', label: 'Macet' },
            ]}
          />
          {errors.last_credit_quality && (
            <p className="text-sm text-red-600 mt-1">{errors.last_credit_quality}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Tunggakan Terakhir (Rp)
          </label>
          <div className="relative">
            <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">
              Rp
            </span>
            <input
              type="text"
              value={formatCurrencyInput(formData.last_arrears)}
              onChange={e => handleCurrencyChange('last_arrears', e.target.value)}
              className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors duration-200"
              placeholder="0"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
